import { Flex, Grid, Text } from '@chakra-ui/react'
import { useMemo } from 'react'
import { formatPrice } from '../../../utils/formatPrice'

export function ResumoPedido({ itens, vlrSubstituicaoTributaria, valorFrete, freteGratis, isDestacaNota }) {
    const summary = useMemo(() => {
        const summaryItems = itens.reduce(
            (acc, item) => {
                const { quantidade, preco_venda } = item
                const total = quantidade * preco_venda

                acc.total += total
                return {
                    ...acc,
                }
            },
            { total: 0, frete: 0, totalPedido: 0 }
        )

        return summaryItems
    }, [itens])

    const totalPedido = !freteGratis ? summary.total + parseFloat(valorFrete) + parseFloat(vlrSubstituicaoTributaria) : summary.total + parseFloat(vlrSubstituicaoTributaria)

    return (
        <>
            <Flex color="white" bgColor="#7fb603" fontSize="12px" textTransform="uppercase" fontWeight="bold" justifyContent="center" alignItems="center" p={3}>
                Resumo do pedido
            </Flex>
            <Grid gridTemplateColumns="repeat(4, 1fr)" border="1px solid #cfcfcf" fontSize="13px">
                <Flex alignItems="center" justifyContent="space-between" py={3} px={4} borderRight="1px solid #cfcfcf">
                    <Text>VALOR TOTAL DOS ITENS:</Text>
                    <Text>{formatPrice(summary.total)}</Text>
                </Flex>
                <Flex alignItems="center" justifyContent="space-between" py={3} px={4} borderRight="1px solid #cfcfcf">
                    <Text>SUBSTITUIÇÃO TRIBUTÁRIA:</Text>
                    <Text>{formatPrice(vlrSubstituicaoTributaria)}</Text>
                </Flex>
                <Flex alignItems="center" justifyContent="space-between" py={3} px={4}>
                    <Text>VALOR DO FRETE:</Text>
                    {/* <Text>{formatPrice(parseFloat(valorFreteDestacado))}</Text> */}
                    <Text>{formatPrice(parseFloat(valorFrete))}</Text>
                </Flex>
                <Flex alignItems="center" justifyContent="space-between" py={3} px={4} bg="#2C2C3A" border="1px solid #2C2C3A" color="white">
                    <Text>VALOR TOTAL DO PEDIDO:</Text>
                    <Text fontWeight="bold">{formatPrice(totalPedido)}</Text>
                </Flex>
            </Grid>
        </>
    )
}
